export const defaultInjuriesAfter = {
    '6wLb36mI0vDjxA4Rk9PB': '',
    '1r4UdvfGBZvybAiwPGK0': ''
};
